<script>
export default {
  mounted() {
    this.$auth.logout();
  }
};
</script>
